var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.5625H13.4583V8.85421H16.2917V8.5C16.2917 4.20577 12.7942 0.70829 8.5 0.70829C4.20577 0.70829 0.70829 4.20577 0.70829 8.5V8.85421H3.54171V9.5625H0V8.5C0 3.81174 3.81174 0 8.5 0C13.1883 0 17 3.81174 17 8.5V9.5625Z",
    fill: "#255097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14648 0.351562H8.8549V2.47656H8.14648V0.351562Z",
    fill: "#255097"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64738 2.85156L4.36279 4.56697L3.86202 5.06787L2.14648 3.35246L2.64738 2.85156Z",
    fill: "#255097"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3541 2.85156L14.855 3.35246L13.1394 5.06787L12.6387 4.56697L14.3541 2.85156Z",
    fill: "#255097"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60112 10.9805C7.56962 10.9805 6.72852 10.1392 6.72852 9.10773C6.72852 8.39062 7.149 7.72656 7.79543 7.41658L12.5767 5.13672L10.2967 9.91797C9.98683 10.5599 9.32277 10.9805 8.60112 10.9805ZM11.0759 6.63306L8.10087 8.05418C7.69802 8.24445 7.43681 8.66066 7.43681 9.10773C7.43681 9.74975 7.95924 10.272 8.60112 10.272C9.04832 10.272 9.45999 10.0108 9.6548 9.60799L11.0759 6.63306Z",
    fill: "#255097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/Meter.30425b39e1385a15d6b1efa875dddee7.svg";
export { ForwardRef as ReactComponent };